import { GET_CHANNELS_SUCCESSFUL, RECALL_ACTIONS_FAIL } from '../types/global';

const initState = {
  actionsFailed: [],
  channels: [],
};

const reducer = (state = initState, payload) => {
  const { type } = payload;
  switch (type) {
    case RECALL_ACTIONS_FAIL:
      return {
        ...state,
        actionsFailed: payload.action ? [...state.actionsFailed, payload.action] : [],
      };
    case GET_CHANNELS_SUCCESSFUL:
      return { ...state, channels: payload.payload || [] };
    default:
      return state;
  }
};

export default reducer;
